(function Module() {
	'use strict';

	var argv = require('minimist')(process.argv.slice(2));
	var now = new Date();
	var cookieApplicationKey = 'MySynch';
	var apiEndpoint = configuration || {
		port: 8000,
		hostname: 'http://localhost',
		dataFeeder: ''
	};
	var tmDefaultsFallback = {
		name: 'Your Local Parnell Territory Manager',
		phone: '800-887-2763',
		email: 'bluecowredcow@parnell.com'
	};

	module.exports = {config : {
		cookies: [{
				applicationKey: cookieApplicationKey,
				key: 'user',
				options: {
					expires: new Date(now.getFullYear() + 25, now.getMonth(), now.getDate())
				}
			},
			{
				applicationKey: cookieApplicationKey,
				key: 'state'
			}
		],

		server: {
			port: 9000,
			hostname: 'localhost'
		},

		apiServer: {
			port:		argv.apiServerPort	|| process.env.API_SERVER_PORT || apiEndpoint.port,
			hostname:	argv.apiServerHost	|| process.env.API_SERVER_HOST || apiEndpoint.hostname
		},

		default: {
			territoryManager: {
				name: argv.defaultTmName	|| process.env.DEFAULT_TM_NAME	|| tmDefaultsFallback.name,
				phone: argv.defaultTmPhone	|| process.env.DEFAULT_TM_PHONE || tmDefaultsFallback.phone,
				email: argv.defaultTmEmail	|| process.env.DEFAULT_TM_EMAIL || tmDefaultsFallback.email
			}
		},

		logging: {
			level: 'debug'
		},

		weather: {
			api: 'http://api.openweathermap.org/data/2.5/weather',
			apiKey: '864a501642d4abe890fa07807ebf34d2'
		},

		deviceId: 'DeviceId',
		
		dataFeeder: argv.dataFeeder || process.env.DATA_FEEDER || apiEndpoint.dataFeeder
	}
  };
  
})();
